<script>
  export let type = "primary";
  export let flat = false;
  export let inverse = false;
</script>

<button class={type} class:flat class:inverse on:click>
  <slot />
</button>

<style>
  button {
    border: 0;
    cursor: pointer;
    border-radius: 6px;
    padding: 8px 12px;
    font-weight: bold;
    box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.2);
  }

  .primary {
    color: white;
    background-color: #d91b42;
  }
  .secondary {
    color: white;
    background-color: #45c496;
  }

  .flat {
    box-shadow: none;
  }
  .primary.inverse {
    background-color: white;
    color: #d91b42;
    border: 2px solid #d91b42;
  }
  .primary.secondary {
    background-color: white;
    color: #45c496;
    border: 2px solid #45c496;
  }
</style>
